const INVENTORY_CLAMP_PATTERN = /due to availability|only\s+\d+\s+items?\s+were\s+added|\d+\s+items?\s+were\s+added|\d+\s+item\s+was\s+added/i;

function extractInventoryClampQuantity(description = '') {
  const match =
    description.match(/only\s+(\d+)\s+items?\s+were\s+added/i) ||
    description.match(/(\d+)\s+items?\s+were\s+added/i) ||
    description.match(/(\d+)\s+item\s+was\s+added/i);

  return match ? parseInt(match[1], 10) : null;
}

async function getActualAddedQty(variantId) {
  try {
    const cart = await fetch('/cart.js').then((response) => response.json());
    const line = cart.items.find((item) => item.variant_id === variantId || item.id === variantId);
    return line ? line.quantity : 0;
  } catch (error) {
    return 0;
  }
}

async function resolveInventoryClampMessage(description, variantId) {
  if (!description || !INVENTORY_CLAMP_PATTERN.test(description)) return null;

  let addedQuantity = extractInventoryClampQuantity(description);
  if (addedQuantity === null && Number.isInteger(variantId)) {
    addedQuantity = await getActualAddedQty(variantId);
  }

  if (addedQuantity === null) return null;

  return (window.cartStrings?.quantityError || description).replace('[quantity]', addedQuantity);
}

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then(async (response) => {
            if (response.status) {
              const variantId = parseInt(formData.get('id'), 10);
              const inventoryClampMessage = await resolveInventoryClampMessage(response.description, variantId);
              const publishedError = inventoryClampMessage || response.errors || response.description || window.cartStrings.error;
              const inlineErrorMessage =
                inventoryClampMessage ||
                response.description ||
                (typeof response.errors === 'string' ? response.errors : window.cartStrings.error);

              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: publishedError,
                message: response.message,
              });
              this.handleErrorMessage(inlineErrorMessage);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('bz-quick-view');
            const BzModal = this.closest('bz-modal');
            if(BzModal){
              BzModal?.close();
            }
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
